import { client } from './client'
import type { User, UserProjectAccess, Role, UserProjectAssignment, UserListItem, WorkflowRunActivity } from '@/types'

export const usersApi = {
  getAll: () =>
    client.get<UserListItem[]>('/users').then(r => r.data),

  me: () =>
    client.get<User>('/users/me').then(r => r.data),

  meProjectAccess: (projectId: string) =>
    client.get<UserProjectAccess>(`/users/me/projects/${projectId}/permissions`).then(r => r.data),

  meWorkflowRunActivity: () =>
    client.get<WorkflowRunActivity>('/users/me/workflow-run-activity').then(r => r.data),

  getRoles: () =>
    client.get<Role[]>('/roles').then(r => r.data),

  getUserAssignments: (userId: string) =>
    client.get<UserProjectAssignment[]>(`/users/${userId}/assignments`).then(r => r.data),

  assignUserToProject: (data: { userId: string; projectId?: string | null; roleId: string }) =>
    client.post<{ assignmentId: string }>('/user-assignments', data).then(r => r.data),

  removeUserFromProject: (assignmentId: string) =>
    client.delete(`/user-assignments/${assignmentId}`),
}
